import axios from 'axios'
import { API } from '../../utils/index'
const instance = axios.create()


export const getNews = async () => {
	const _endpoint = 'news'
	const URL = `${API}/${_endpoint}`
	return instance.get(URL)
}


export const getNew = async (id) => {
	const _endpoint = `news/${id}`
	const URL = `${API}/${_endpoint}`

	return instance.get(URL)
}